// @ts-nocheck
import type { HTMLAST } from './types';

const isWistiaNode = (node: HTMLAST) => {
  return (
    node.tagName &&
    node.tagName === 'div' &&
    node.attrs &&
    node.attrs['data-wistia-video'] === 'true'
  );
};

export default isWistiaNode;
